<template>
  <div>
    <div id="CustomHomeSlider" ref="CustomHomeSlider">
      <div id="viewer" ref="viewer" :style="{marginLeft: viewerLeftMargin}">
        <div id="track" ref="track">
          <div
              class="tile"
              :style="{
            width:  tileWidth + 'px',
            height: tileHeight + 'px',
            paddingLeft: tilePaddingLeft + 'px',
            paddingRight: tilePaddingRight + 'px'
          }"
              v-for="(item,i) in items" :key="'slider-card-' + i"
          >
            <div class="innerTile" :class="{hiddenCard: hideCards}">
              <ServicesCard
                  v-if="tileType === 'services'"
                  :item="item"
                  :tile-height="tileHeight"
                  :index="i"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="arrowLeft arrow" :style="{top: (tileHeight / 2 - 20) + 'px', marginLeft: viewerLeftMargin }" :class="{fadeOut: page <= 1}">
        <i class="fa-solid fa-chevron-left" @click="goBack" v-if="page > 1"></i>
      </div>
      <div class="arrowRight arrow" :style="{top: (tileHeight / 2 - 20) + 'px', marginRight: viewerLeftMargin}" :class="{fadeOut: totalPages <= page}">
        <i class="fa-solid fa-chevron-right" @click="goForward" v-if="totalPages > page"></i>
      </div>
    </div>
  </div>
</template>

<script>

import ServicesCard from "@/components/Home/New/ServicesCard.vue";
import EventBus from "@/helpers/eventbus";


export default {
  name: "CustomHomeSlider",
  components: {
    ServicesCard
  },
  props: {
    tileType: {
      type: String
    },
  },
  data() {
    return {
      items: [],
      sliderWidth: 0,
      screenWidth: 0,
      sideNavWidth: 0,
      scrolling: false,
      hideCards: true,
      aspectRatio: {
        width: 138,
        height: 200
      },
      page: 1,
      showOptions: {
        tilesToShow: 5,
        responsive: [
          {max: 680, tilesToShow: 2},
          {max: 880, tilesToShow: 3},
          {max: 1400, tilesToShow: 4}
        ]
      }
    }
  },
  methods: {
    async getServicesData() {
      let res = await this.api({
        path: "api/u/home/get-front-door-banner-v2",
      });
      if (res.success) {
        this.items = res.banner;
      }
    },
    goBack() {
      if(this.page === 1 || this.scrolling) return;
      this.scrolling = true;
      this.page = Math.max(1, this.page - 1);
      this.scrollToPage();
      setTimeout(()=> {
        this.scrolling = false;
      }, 500)
    },
    goForward() {
      if(this.page === this.totalPages || this.scrolling) return;
      this.scrolling = true;
      this.page = Math.min(this.page + 1, this.totalPages);
      this.scrollToPage();
      setTimeout(()=> {
        this.scrolling = false;
      }, 500)
    },
    scrollToPage() {
      if(this.$refs.viewer) {
        this.$refs.viewer.scrollLeft = (this.page - 1) * this.sliderWidth;
      }
    },
    updateTiles() {
      this.screenWidth = document.documentElement.clientWidth - this.sideNavWidth;
      this.sliderWidth = Math.min(2000, this.screenWidth);
      this.page = 1;
      this.$nextTick(this.scrollToPage);
    },
  },
  computed: {
    viewerLeftMargin() {
      if(this.sliderWidth < this.screenWidth) return ((this.screenWidth - this.sliderWidth) / 2) + 'px';
      return 0;
    },
    tileHeight() {
      const aspectRatio = this.aspectRatio.width / this.aspectRatio.height
      return Math.floor((this.tileWidth - this.tilePaddingLeft - this.tilePaddingRight) / aspectRatio);
    },
    tilePaddingRight() {
      return Math.floor(this.tileWidth * 0.055);
    },
    tilePaddingLeft() {
      return Math.floor(this.tileWidth * 0.025);
    },
    tileWidth() {
      return Math.floor(this.sliderWidth / this.tilesToShow);
    },
    tilesToShow() {
      let max = 10000;
      let tilesToShow = this.showOptions.tilesToShow;
      this.showOptions.responsive.forEach(option => {
        if(option.max > this.sliderWidth && option.max < max) {
          max = option.max;
          tilesToShow = option.tilesToShow
        }
      })
      return tilesToShow;
    },
    totalPages() {
      return Math.ceil(this.items.length / this.tilesToShow)
    },
  },
  mounted() {
    this.updateTiles();
    this.getServicesData();
    EventBus.$on("sideNavExpanded",(expanded) => {
      if(!this.$refs.CustomHomeSlider) {
        return;
      }
      this.sideNavWidth = expanded ? 250 : 0;
      this.updateTiles();
    })
    window.addEventListener('resize', this.updateTiles);
    setTimeout(()=> {
      this.hideCards = false;
    },1000)
  },
  destroyed() {
    window.removeEventListener('resize', this.updateTiles);
  },
  watch: {
    items() {
      this.updateTiles()
    },
    tileWidth() {
      this.scrollToPage();
    }
  }
}
</script>

<style lang="less">
#CustomHomeSlider {
  width: 100%;
  padding-top: 25px;
  margin-bottom: 25px;
  position: relative;
  #viewer {
    max-width: 2000px;
    width: 100%;
    overflow: hidden;
    scroll-behavior: smooth;
    height: 100%;
  }
  #track {
    display: flex;
    height: 100%;
    width: 50000px;
  }
  .tile {
    .innerTile {
      border-radius: 10px;
      height: 100%;
      width: 100%;
      transition: opacity 1s ease-out;
      opacity: 1;
      &.hiddenCard {
        opacity: 0 !important;
      }
    }
  }
  .arrow {
    position: absolute;
    height: 100px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    z-index: 100;
    transition: opacity 0.5s linear;
    background-color: rgba(0,0,0,0.5);
    &.fadeOut {
      opacity: 0;
    }
    i {
      cursor: pointer;
      color: white;
      font-size: 20px;
    }
  }
  .arrowLeft {
    left: 0;
    border-radius: 0 5px 5px 0;
  }
  .arrowRight {
    right: 0;
    border-radius: 5px 0 0 5px;
  }
}
</style>
